// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2d24cd09","885":"d1fc458b"}[chunkId] + ".chunk.js";
};